import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, AlertCircle } from 'lucide-react';
export function ProblemSection() {
  const failedSolutions = [{
    title: 'Plantillas de farmacia',
    desc: 'Solo acolchan el dolor momentáneamente, pero no eliminan la rigidez de la fascia.'
  }, {
    title: 'Reposo absoluto',
    desc: 'Es imposible cuando el mundo depende de que tú estés de pie trabajando.'
  }, {
    title: 'Analgésicos',
    desc: "Solo 'apagan la alarma', mientras el tejido de tu talón sigue sufriendo micro-desgarros."
  }, {
    title: "Estirar 'en frío'",
    desc: 'Hacerlo al levantarte puede estar empeorando la inflamación en lugar de curarla.'
  }];
  return <section className="py-20 bg-white" data-id="element-167">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-168">
        {/* Hook */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-169">
          <AlertCircle className="w-12 h-12 text-accent-500 mx-auto mb-6" data-id="element-170" />
          <p className="text-xl md:text-2xl font-medium text-slate-800 leading-relaxed" data-id="element-171">
            Si cada mañana te sientas en el borde de la cama con miedo a poner
            el pie en el suelo, sabes exactamente de qué dolor estamos hablando.{' '}
            <span className="text-brand-600 font-bold" data-id="element-172">
              Esa punzada eléctrica en el talón que parece un clavo ardiendo
              atravesando tu pie.
            </span>{' '}
            No tiene por qué ser así.
          </p>
        </motion.div>

        {/* Specific Problem */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-slate-50 rounded-3xl p-8 md:p-12 mb-20 border border-slate-100 shadow-sm" data-id="element-173">
          <h2 className="text-3xl font-display font-bold text-slate-900 mb-6 text-center" data-id="element-174">
            Tus pies no son un lujo, son tu herramienta de trabajo
          </h2>
          <p className="text-lg text-slate-600 mb-6 leading-relaxed" data-id="element-175">
            Para las mujeres que pasamos horas de pie —ya sea en un hospital, en
            limpieza, en una tienda o cuidando a la familia— la fascitis plantar
            no solo duele; te roba la energía, te pone de mal humor y te hace
            sentir agotada antes de que empiece el turno.
          </p>
          <p className="text-lg text-slate-600 font-medium border-l-4 border-brand-500 pl-4 py-2 bg-white rounded-r-lg shadow-sm" data-id="element-176">
            Ese primer paso de la mañana se ha convertido en una tortura diaria
            que afecta cómo empiezas tu jornada y cómo regresas a casa por la
            noche.
          </p>
        </motion.div>

        {/* What didn't work */}
        <div data-id="element-177">
          <h3 className="text-2xl font-display font-bold text-center text-slate-900 mb-10" data-id="element-178">
            Por qué lo que has intentado NO ha funcionado
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-179">
            {failedSolutions.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex gap-4 p-6 bg-white rounded-2xl border border-red-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-180">
                <XCircle className="w-8 h-8 text-red-500 flex-shrink-0" data-id="element-181" />
                <div data-id="element-182">
                  <h4 className="font-bold text-slate-900 mb-2" data-id="element-183">
                    {item.title}
                  </h4>
                  <p className="text-slate-600 text-sm leading-relaxed" data-id="element-184">
                    {item.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}